export enum BusinessFormType {
  HolidayTrip = 1,
  TravelRequest = 2
}

export enum TransportationSystemType {
  Other = 1,
  Plane = 2,
}

export enum ApprovalStatus {
  Draft = 0,
  Pending = 1,
  Approved = 2,
  Declined = 3,
  RequireMoreInfo = 4
}

export enum AirlineRating {
  Class1 = 1,
  Class2 = 2,
  Class3 = 3,
  Class4 = 4,
  Class5 = 5
}

export enum AirlineStatus {
  Approved = 1,
  ApprovedDeviation = 2,
  NonApproved = 3
}

export enum DeviationTeamType {
  Aviation = 1,
  Health = 2,
  Security = 3,
  RIC = 4
}

export enum DeviationType {
  SingleInstance = 1,
  EntityWide = 2
}

export enum DeviationWorkflowType {
  Aviation = 1,
  Health = 2,
  Security = 3
}

export enum DeviationDetailType {
  Airline = 1,
  ClassOfTravel = 2,
  Hotel = 3,
  AirlineExtended = 4
}

export enum DeviationRequestStatus {
  Pending = 1,
  Supported = 2,
  Rejected = 3,
  Expired = 4,
  SupportedByRegionDirector = 5
}

export enum ClassOfTravel {
  Economy = 1,
  Business = 2
}

export enum FlightTime {
  Short = 1,
  Medium = 2,
  Long = 3
}

export enum LocationCurrentnessStatus {
  OneHour = 1,
  OneDay = 2,
  Older = 3
}

export enum UserLocationRequestStatus {
  Pending = 1,
  Approved = 2,
  Declined = 3,
  NotAvailable = 4
}
